import { render, staticRenderFns } from "./OrdersNav.vue?vue&type=template&id=62b5dc99"
import script from "./OrdersNav.vue?vue&type=script&lang=js"
export * from "./OrdersNav.vue?vue&type=script&lang=js"
import style0 from "./OrdersNav.vue?vue&type=style&index=0&id=62b5dc99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports